import { left } from "@popperjs/core";
import React, { Component } from "react";

class HeaterLegend extends Component {


  
  render() {
    const buttonStyles = {
  container: {
    top: "0px",
    left: "50%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "10px",
  },

  button: {
    border: "none",
    padding: "8px 18px",
    borderRadius: "25px",
    fontSize: "13px",
    fontWeight: "600",
    color: "white",
    cursor: "pointer",
    transition: "0.3s",
    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
  },

  btn1: { background: "#f5a000" }, // amarillo
  btn2: { background: "#1e90ff" }, // azul
  btn3: { background: "#ff00ff" }, // rosado
  btn4: { background: "#0a8f08" }, // verde
  btn5: { background: "#666666" }, // gris
};
    return (
     

  <div style={buttonStyles.container}>
    <button style={{ ...buttonStyles.button, ...buttonStyles.btn1 }}>
      {this.props.chartLegend1}
    </button>

    <button style={{ ...buttonStyles.button, ...buttonStyles.btn2 }}>
      {this.props.chartLegend2}
    </button>

    <button style={{ ...buttonStyles.button, ...buttonStyles.btn3 }}>
      {this.props.chartLegend3}
    </button>

    <button style={{ ...buttonStyles.button, ...buttonStyles.btn4 }}>
      {this.props.chartLegend4}
    </button>

    <button style={{ ...buttonStyles.button, ...buttonStyles.btn5 }}>
      {this.props.chartLegend5}
    </button>
  </div>);
  }
}

export default HeaterLegend;